/**
 * Returns Dynamic Generated CSS
 */

import generateCSS from '@Controls/generate-css';
import generateCSSUnit from '@Controls/generate-css-unit';

function HowToChildStyle(props) {
	const {
		headingAlign,
		headingColor,
		subHeadingColor,
		headFontSize,
		headFontSizeType,
		headFontSizeTablet,
		headFontSizeMobile,
		headFontFamily,
		headFontWeight,
		headLineHeightType,
		headLineHeight,
		headLineHeightTablet,
		headLineHeightMobile,
		subHeadFontSize,
		subHeadFontSizeType,
		subHeadFontSizeTablet,
		subHeadFontSizeMobile,
		subHeadFontFamily,
		subHeadFontWeight,
		subHeadLineHeightType,
		subHeadLineHeight,
		subHeadLineHeightTablet,
		subHeadLineHeightMobile,
		separatorWidthType,
		headSpace,
		subHeadSpace,
		iconimgPosition,
		iconimgBorderRadius,
		seperatorStyle,
		seperatorWidth,
		seperatorColor,
		seperatorThickness,
		seperatorSpace,
		ctaLinkColor,
		ctaFontSize,
		ctaFontSizeType,
		ctaFontSizeMobile,
		ctaFontSizeTablet,
		ctaFontFamily,
		ctaFontWeight,
		ctaBtnLinkColor,
		ctaBgColor,
		ctaBtnVertPadding,
		ctaBtnHrPadding,
		ctaBorderStyle,
		ctaBorderColor,
		ctaBorderWidth,
		ctaBorderRadius,
		iconLeftMargin,
		iconRightMargin,
		iconTopMargin,
		iconBottomMargin,
		imageWidth,
		imageWidthType,
		ctaLinkHoverColor,
		ctaBgHoverColor,
		ctaBorderhoverColor,
		ctaIconSpace,
		blockPadding,
	} = props.attributes;

	const selectors = {
		// Icon css
		' .wpsp-how-to__content-wrap .wpsp-ifb-imgicon-wrap': {
			'margin-left': generateCSSUnit(iconLeftMargin, 'px'),
			'margin-right': generateCSSUnit(iconRightMargin, 'px'),
			'margin-top': generateCSSUnit(iconTopMargin, 'px'),
			'margin-bottom': generateCSSUnit(iconBottomMargin, 'px'),
		},
		' .wpsp-howto-child .wpsp-ifb-image-content img': {
			'border-radius': generateCSSUnit(iconimgBorderRadius, 'px'),
		},
		// CTA style
		' .wpsp-howto-child-cta-link': {
			'font-size': generateCSSUnit(ctaFontSize, ctaFontSizeType),
			'font-family': ctaFontFamily,
			'font-weight': ctaFontWeight,
			color: ctaLinkColor,
		},
		' .wpsp-howto-child-cta-link:hover': {
			color: ctaLinkHoverColor,
		},
		' .wpsp-howto-child-cta-link .wpsp-ifb-text-icon': {
			'font-size': generateCSSUnit(ctaFontSize, ctaFontSizeType),
			height: generateCSSUnit(ctaFontSize, ctaFontSizeType),
			width: generateCSSUnit(ctaFontSize, ctaFontSizeType),
			'line-height': generateCSSUnit(ctaFontSize, ctaFontSizeType),
		},
		' .wpsp-howto-child-cta-link .wpsp-ifb-button-icon': {
			'font-size': generateCSSUnit(ctaFontSize, ctaFontSizeType),
			height: generateCSSUnit(ctaFontSize, ctaFontSizeType),
			width: generateCSSUnit(ctaFontSize, ctaFontSizeType),
			'line-height': generateCSSUnit(ctaFontSize, ctaFontSizeType),
		},
		' .wpsp-howto-child-cta-link svg': {
			fill: ctaLinkColor,
		},
		' .wpsp-howto-child-cta-link:hover svg': {
			fill: ctaLinkHoverColor,
		},
		' .wpsp-ifb-button-wrapper .wpsp-howto-child-cta-link': {
			color: ctaBtnLinkColor,
			'background-color': ctaBgColor,
			'border-style': ctaBorderStyle,
			'border-color': ctaBorderColor,
			'border-radius': generateCSSUnit(ctaBorderRadius, 'px'),
			'border-width': generateCSSUnit(ctaBorderWidth, 'px'),
			'padding-top': generateCSSUnit(ctaBtnVertPadding, 'px'),
			'padding-bottom': generateCSSUnit(ctaBtnVertPadding, 'px'),
			'padding-left': generateCSSUnit(ctaBtnHrPadding, 'px'),
			'padding-right': generateCSSUnit(ctaBtnHrPadding, 'px'),
		},
		' .wpsp-ifb-button-wrapper:hover .wpsp-howto-child-cta-link': {
			color: ctaLinkHoverColor,
			'background-color': ctaBgHoverColor,
			'border-color': ctaBorderhoverColor,
		},
		' .wpsp-ifb-button-wrapper .wpsp-howto-child-cta-link svg': {
			fill: ctaBtnLinkColor,
		},
		' .wpsp-ifb-button-wrapper .wpsp-howto-child-cta-link:hover svg': {
			fill: ctaLinkHoverColor,
		},
		// Title Style
		' .block-editor-rich-text__editable.wpsp-ifb-title': {
			'font-size': generateCSSUnit(headFontSize, headFontSizeType),
			'font-family': headFontFamily,
			'font-weight': headFontWeight,
			'line-height': generateCSSUnit(headLineHeight, headLineHeightType),
			color: headingColor,
			'margin-bottom': generateCSSUnit(headSpace, 'px'),
		},
		// Description Style
		' .wpsp-ifb-text-wrap .block-editor-rich-text__editable.wpsp-ifb-desc': {
			'font-size': generateCSSUnit(subHeadFontSize, subHeadFontSizeType),
			'font-family': subHeadFontFamily,
			'font-weight': subHeadFontWeight,
			'line-height': generateCSSUnit(
				subHeadLineHeight,
				subHeadLineHeightType
			),
			color: subHeadingColor,
			'margin-bottom': generateCSSUnit(subHeadSpace, 'px'),
		},
		// Seperator
		' .wpsp-ifb-separator': {
			width: generateCSSUnit(seperatorWidth, separatorWidthType),
			'border-top-width': generateCSSUnit(seperatorThickness, 'px'),
			'border-top-color': seperatorColor,
			'border-top-style': seperatorStyle,
		},
		' .wpsp-ifb-separator-parent': {
			'margin-bottom': generateCSSUnit(seperatorSpace, 'px'),
		},
		' .wpsp-ifb-content': {
			padding:
				typeof blockPadding !== 'undefined'
					? blockPadding + 'px'
					: 'inherit',
		},
		' .wpsp-ifb-align-icon-after': {
			'margin-left': generateCSSUnit(ctaIconSpace, 'px'),
		},
		' .wpsp-ifb-align-icon-before': {
			'margin-right': generateCSSUnit(ctaIconSpace, 'px'),
		},
	};

	if (imageWidthType) {
		// Image
		selectors[' .wpsp-ifb-image-content img'] = {
			width: generateCSSUnit(imageWidth, 'px'),
			'max-width': generateCSSUnit(imageWidth, 'px'),
		};
	}

	if (
		iconimgPosition === 'above-title' ||
		iconimgPosition === 'below-title'
	) {
		selectors[' .wpsp-how-to__content-wrap'] = {
			'text-align': headingAlign,
		};
	}

	const tabletSelectors = {
		' .wpsp-ifb-text-wrap .block-editor-rich-text__editable.wpsp-ifb-desc': {
			'font-size': generateCSSUnit(
				subHeadFontSizeTablet,
				subHeadFontSizeType
			),
			'line-height': generateCSSUnit(
				subHeadLineHeightTablet,
				subHeadLineHeightType
			),
		},
		' .block-editor-rich-text__editable.wpsp-ifb-title': {
			'font-size': generateCSSUnit(headFontSizeTablet, headFontSizeType),
			'line-height': generateCSSUnit(
				headLineHeightTablet,
				headLineHeightType
			),
		},
		' .wpsp-howto-child-cta-link': {
			'font-size': generateCSSUnit(ctaFontSizeTablet, ctaFontSizeType),
		},
		' .wpsp-howto-child-cta-link .wpsp-ifb-text-icon': {
			'font-size': generateCSSUnit(ctaFontSizeTablet, ctaFontSizeType),
			height: generateCSSUnit(ctaFontSizeTablet, ctaFontSizeType),
			'line-height': generateCSSUnit(ctaFontSizeTablet, ctaFontSizeType),
			width: generateCSSUnit(ctaFontSizeTablet, ctaFontSizeType),
		},
		' .wpsp-howto-child-cta-link .wpsp-ifb-button-icon': {
			'font-size': generateCSSUnit(ctaFontSizeTablet, ctaFontSizeType),
			height: generateCSSUnit(ctaFontSizeTablet, ctaFontSizeType),
			'line-height': generateCSSUnit(ctaFontSizeTablet, ctaFontSizeType),
			width: generateCSSUnit(ctaFontSizeTablet, ctaFontSizeType),
		},
	};

	const mobileSelectors = {
		' .wpsp-ifb-text-wrap .block-editor-rich-text__editable.wpsp-ifb-desc': {
			'font-size': generateCSSUnit(
				subHeadFontSizeMobile,
				subHeadFontSizeType
			),
			'line-height': generateCSSUnit(
				subHeadLineHeightMobile,
				subHeadLineHeightType
			),
		},
		' .block-editor-rich-text__editable.wpsp-ifb-title': {
			'font-size': generateCSSUnit(headFontSizeMobile, headFontSizeType),
			'line-height': generateCSSUnit(
				headLineHeightMobile,
				headLineHeightType
			),
		},
		' .wpsp-howto-child-cta-link': {
			'font-size': generateCSSUnit(ctaFontSizeMobile, ctaFontSizeType),
		},
		' .wpsp-howto-child-cta-link .wpsp-ifb-text-icon': {
			'font-size': generateCSSUnit(ctaFontSizeMobile, ctaFontSizeType),
			height: generateCSSUnit(ctaFontSizeMobile, ctaFontSizeType),
			'line-height': generateCSSUnit(ctaFontSizeMobile, ctaFontSizeType),
			width: generateCSSUnit(ctaFontSizeMobile, ctaFontSizeType),
		},
		' .wpsp-howto-child-cta-link .wpsp-ifb-button-icon': {
			'font-size': generateCSSUnit(ctaFontSizeMobile, ctaFontSizeType),
			height: generateCSSUnit(ctaFontSizeMobile, ctaFontSizeType),
			'line-height': generateCSSUnit(ctaFontSizeMobile, ctaFontSizeType),
			width: generateCSSUnit(ctaFontSizeMobile, ctaFontSizeType),
		},
	};

	const id = `.block-editor-page #wpwrap .wpsp-block-${props.clientId.substr(
		0,
		8
	)}`;
	let stylingCss = generateCSS(selectors, id);

	stylingCss += generateCSS(tabletSelectors, id, true, 'tablet');

	stylingCss += generateCSS(mobileSelectors, id, true, 'mobile');
	return stylingCss;
}

export default HowToChildStyle;
